"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

var _reactDropzone = require("react-dropzone");

var _file = require("../../../util/file");

var _flags = _interopRequireDefault(require("../../../util/flags"));

var _PlangridLaunchDarklyProvider = require("../../../util/PlangridLaunchDarklyProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Container = _styledComponents.default.div`
  border: 1px dashed ${_alloyReactTheme.default.colors.charcoal400};
  border-radius: 2px;
  height: 300px;
  padding: 30px;
  text-align: center;
  position: relative;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => {
  if (props.error && !props.disabled) {
    return `
        background-color: #FFEEEA;
        border: none;
      `;
  } else if (props.dragged && !props.disabled) {
    return `
        background-color: #ecf1fc;
        border: none;
  `;
  }

  return "";
}}
`;

const DropZone = ({
  children,
  disabled,
  fileDropHandler
}) => {
  const {
    value: allowHEIC
  } = (0, _PlangridLaunchDarklyProvider.usePlangridFeatureFlag)(_flags.default.PHOTO_HEIC, false);
  const supportedMimeTypes = allowHEIC ? _file.SUPPORTED_MIME_TYPES_WITH_HEIC : _file.SUPPORTED_MIME_TYPES;
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject
  } = (0, _reactDropzone.useDropzone)({
    onDrop: fileDropHandler,
    disabled,
    accept: supportedMimeTypes,
    noClick: true,
    noDragEventsBubbling: true
  });
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    disabled: disabled,
    dragged: isDragActive,
    error: isDragReject,
    "data-qa": "UploadPhotos.DropZone"
  }, getRootProps()), /*#__PURE__*/_react.default.createElement("input", getInputProps()), children);
};

var _default = DropZone;
exports.default = _default;